// actions.js

import axios from 'axios';


export default {
    async fetchSaveIncident(ctx, payload){
        try{
            const access_token = ctx.rootGetters.access_token;
            const response = await axios.post(
                `${process.env.VUE_APP_APIGATEWAY}/api/v1/incidents`,
                payload,
                {
                    headers: {
                        'Authorization': `${access_token}`
                    }
                }
            );
            return {
                status: response.status,
                data: response.data
            };
        } catch (error) {
            if (error.response) {
                // Сервер вернул ответ с ошибкой (код статуса не в диапазоне 2xx)
                return {
                    status: error.response.status,
                    message: error.response.data.message || 'Registration failed'
                };
            } else if (error.request) {
                // Запрос был сделан, но ответа не получено
                return {
                    status: 0,
                    message: 'No response received from server'
                };
            } else {
                // Что-то пошло не так при настройке запроса
                return {
                    status: -1,
                    message: error.message
                };
            }
        }
    },
    async fetchDeleteIncident(ctx, payload) {
        try {
            const access_token = ctx.rootGetters.access_token;
            const response = await axios.delete(
                `${process.env.VUE_APP_APIGATEWAY}/api/v1/incidents/${payload.id}`,
                {
                    headers: {
                        'Authorization': `${access_token}`
                    }
                }
            );
            return {
                status: response.status,
                data: response.data
            };
        } catch (error) {
            if (error.response) {
                return {
                    status: error.response.status,
                    message: error.response.data.message || 'Delete failed'
                };
            } else if (error.request) {
                return {
                    status: 0,
                    message: 'No response received from server'
                };
            } else {
                return {
                    status: -1,
                    message: error.message
                };
            }
        }
    },
};
